var React = require('react');

function HandsHQ (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"32","height":"32","rx":"16","fill":"#0A182E","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M18.6554 10.1428H24.7738L13.0003 21.9163L7.08398 16L10.1432 12.9408L13.0003 15.7979L18.6554 10.1428ZM12.6554 15.8571L10.1432 13.3449L7.6309 15.8571H12.6554ZM7.6309 16.1428H12.8574V21.3694L7.6309 16.1428ZM13.1432 21.3694V16.1428H18.3697L13.1432 21.3694ZM18.8574 15.6551V10.4285H24.084L18.8574 15.6551ZM18.5717 10.6306V15.8571H13.3452L18.5717 10.6306Z","fill":"#65DCA4","stroke":"#39D08F","strokeWidth":"0.5","strokeLinejoin":"round","key":1})]);
}

HandsHQ.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = HandsHQ;

HandsHQ.default = HandsHQ;
